import { TagWebDto } from '@/features/dashboard/tags/types/TagWebDto.ts';
import {
  TagFormData,
  TagFormInput,
} from '@/features/dashboard/tags/schemas/tagSchema.ts';

export const tagMapper = {
  fromFormToDto(form: TagFormData, id: string | null = null): TagWebDto {
    return {
      id,
      name: form.name.trim(),
      color: form.color.toUpperCase(),
    };
  },

  fromDtoToForm(dto: TagWebDto): TagFormInput {
    return {
      name: dto.name,
      color: dto.color.toUpperCase(),
    };
  },
};
